import React, { Component, forwardRef, useEffect, useState } from 'react'
import { includes, result, isEmpty, find } from 'libraries/lodash'
import TableRow from './Row'
import { SeeAllFilters } from '../filters'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import Zoom from '@material-ui/core/Zoom'
import MuiTableBody from '@material-ui/core/TableBody'
import MuiTableContainer from '@material-ui/core/TableContainer'
import MuiTable from '@material-ui/core/Table'
import MuiTableHead from '@material-ui/core/TableHead'
import TableHeader from './Header'
import url from 'front-end-core/core/url'
import { MW_DEAL_DETAILS, MW_LIST_DEALS } from 'constants/controllers'
import { pushUrl } from 'front-end-core/core/history'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const TableContainer = (props) => {
  const {
    parameters,
    searchPhrase,
    showDealType,
    selectedDealType,
    state,
    onSelect,
    selectedDealName,
    deals: { results },
    dealType
  } = props
  const [filteredEnabled, setFiltersEnabled] = useState(false)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    try {
      if (searchPhrase) {
        setFiltersEnabled(true)
      }

      if (parameters) {
        setFiltersEnabled(!isEmpty(JSON.parse(parameters)))
      }
    } catch (error) {
      setFiltersEnabled(false)
    }
  }, [searchPhrase, parameters])

  return (
    <div>
      <MuiTableContainer>
        <MuiTable>
          <MuiTableHead classes={{ root: 'bg-white b bb-medium bt-thick b--dark-sea-green-3 mt1' }}>
            <TableHeader
              {...{ showDealType, selectedDealType, state, onSelect, selectedDealName }}
              isHeader
            />
          </MuiTableHead>
          <TableBody {...{ ...props, aol }} />
        </MuiTable>
      </MuiTableContainer>
      {isEmpty(results) && <TableNoResults {...{ ...props, aol }} />}
      {filteredEnabled && <ClearFiltersDialog {...{ dealType, aol }} />}
    </div>
  )
}

export default TableContainer

class TableBody extends Component {
  getRestrictingValue (paramName, value) {
    const restrictingValues = result(this.props.documentParameters, [paramName, 'restrictingValues'], [])
    const foundValue = find(restrictingValues, p => p.value === value)
    return result(foundValue, 'displayName')
  }

  getMarket = deal => {
    return ['IPO-23', 'SO-26', 'PMA-18'].reduce(
      (acc, param) =>
        acc ||
        this.getRestrictingValue(
          param,
          result(deal, ['params', param, 'value'])
        ),
      undefined
    )
  }

  isSelected = (id, dealType) => {
    const { selectedDeals, selectedDealType } = this.props
    return selectedDealType === dealType || selectedDealType === null || selectedDealType === 'all'
      ? +includes(selectedDeals, id)
      : -2
  }

  toggleSelected = (id, dealType) => e => {
    const { checkSelectionAbility, setSelectedDeals } = this.props
    if (this.isSelected(id, dealType) <= 0) {
      checkSelectionAbility(1, () => {
        setSelectedDeals({ select: [id], dealType })
      })
    } else {
      setSelectedDeals({ deselect: [id], dealType })
    }
  }

  getDealTypeName (type) {
    return result(this.props.eventTypes, [type, 'name'], type)
  }

  render () {
    const {
      deals: { results },
      dealType,
      aol,
      isLogged,
      setSignUpModalIsOpen
    } = this.props
    const showDealType = dealType === 'all'

    return (
      <MuiTableBody className='bg-white'>
        {results.map((deal, key) => (
          <TableRow
            key={key}
            deal={deal.title}
            dealType={this.getDealTypeName(deal.dealType)}
            date={deal.primaryDate.format('DD/MM/YYYY')}
            market={this.getMarket(deal)}
            checked={this.isSelected(deal.dealId, deal.dealType)}
            onSelect={this.toggleSelected(deal.dealId, deal.dealType)}
            href={url(MW_DEAL_DETAILS, { aol, dealId: deal.dealId })}
            showDealType={showDealType}
            {...{ isLogged, setSignUpModalIsOpen }}
          />
        ))}
      </MuiTableBody>
    )
  }
}

const TableNoResults = props => (
  <div className='tc pa6'>
    <>
      <section className='f4 fw6 pb5 pt6'>
        Search returned no results.{' '}
      </section>
      <SeeAllFilters
        {...props}
        inline={
          <span className='lh-solid vbs ml4'>
            Update filters
          </span>
        }
      />
    </>
  </div>
)

const Transition = forwardRef(function Transition (props, ref) {
  return <Zoom ref={ref} {...props} />
})

const ClearFiltersDialog = ({ dealType, aol }) => {
  const [open, setOpen] = useState(false)
  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleOnConfirmClick = () => pushUrl(url(MW_LIST_DEALS, { aol, dealType }))

  return (
    <div className='tc pa6'>
      <a href={null} className='i pointer underline' onClick={handleClickOpen}>
        Reset all filters and text search
      </a>
      <Dialog open={open} onClose={handleClose} TransitionComponent={Transition}>
        <DialogTitle className='black'>Are you sure you want to reset all filters?</DialogTitle>
        <DialogActions>
          <Grid container spacing={2} className='ph6 pb4'>
            <Grid item xs={12} sm={6}>
              <Button
                variant='contained'
                className='outline-0'
                classes={{ root: 'ttc w-100 bg-teal' }}
                onClick={handleOnConfirmClick}
                color='primary'
                autoFocus
              >
                Confirm
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant='contained'
                className='outline-0'
                classes={{ root: 'ttc w-100' }}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  )
}
